<template>
  <div class="reveal large" :id="'modal-ytvideo-' + videoId" data-reveal>
    <div class="responsive-embed widescreen content">
      <youtube
        :video-id="videoId"
        @ready="ready"
        v-if="isOpen"
      ></youtube>
    </div>
    <button
      class="close-button"
      data-close
      aria-label="Close modal"
      type="button"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "SearchYoutubePlayer",
  data() {
    return {
      player: null,
    };
  },
  computed: {
    videoId() {
      return this.item.metaData.videoId;
    },
  },
  props: {
    item: {
      type: Object,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isOpen(newVal, oldVal) {
      if (newVal) {
        this.open();
      }
    },
  },

  mounted() {
    if (!this.reveal) {
      const el = $(`#modal-ytvideo-${this.videoId}`);
      this.reveal = new Foundation.Reveal(el, {
        animationIn: "fade-in-up fast",
      });

      el.on("closed.zf.reveal", () => {
        this.player.stopVideo();
        this.$emit("closed");
      });
    }
  },

  methods: {
    open() {
      this.reveal.open();
    },
    close() {
      this.player.stopVideo();
      this.$emit("closed");
    },
    ready(player) {
      this.player = player;
      this.player.playVideo();
    }
  },
};
</script>

<style scoped>
/* .modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  max-width: 60rem;
  width: 90%;
} */
</style>


// WEBPACK FOOTER //
// searchYoutubePlayer.vue?9371e344